import "@hotwired/turbo-rails";
import "cookieconsent";
import "./controllers";

window.cookieconsent.initialise({
  palette: {
    popup: {
      background: "#422034",
    },
    button: {
      background: "#FF6B50",
      text: "#422034",
    },
  },
  position: "bottom-left",
  content: {
    message: document.body.dataset.cookieMessage,
    dismiss: document.body.dataset.cookieDismiss,
    link: document.body.dataset.cookieReadMore,
    href: "/privacy_policy#cookies"
  },
});
